import { apiClient } from '../../ruutsApi/client'
import endpoints from '../../ruutsApi/endpoints'
import { unwrapCollection } from '../../ruutsApi/normalize'

export default async function getMonitoringSites({ farmId, signal }) {
  const response = await apiClient.get(endpoints.sites, { params: { farmId }, signal })
  return unwrapCollection(response)
}
